/**
 * Styled Components - Created by cazarez on 12/03/18.
 */
import styled from 'styled-components'
import Breadcrumb from 'antd/lib/breadcrumb'
import Button from 'antd/lib/button'
import BackTop from 'antd/lib/back-top'
import Select from 'antd/lib/select'
import Popover from 'antd/lib/popover'
import InputComponent from 'antd/lib/input'
import InputNumber from 'antd/lib/input-number'

import {
  RED,
  BLUE_DARK,
  DARKER_GRAY,
  GRAY,
  GRAY_DARK,
  GRAY_LIGHT,
  GRAY_HEADER,
  WHITE,
  BLUE,
  BLUE_SKY,
  GREEN_STATUS,
  BLACK_3D_DARK,
  GRAY_LIGHTEST,
  BLACK_BG,
  GRAY_ANTDESIGN
} from '../../theme/colors'
import Icon from 'antd/lib/icon'

interface StyledProps {
  selected?: boolean
  withBorder?: boolean
  marginLeft?: string
  disabled?: boolean
  highlight?: boolean
  secondary?: boolean
}

export const Container = styled.div`
  background-color: ${WHITE};
  max-width: 1452px;
  width: 100%;
  margin: 0 auto;
  box-shadow: 0px 5px 14px 8px #c7c7c7;
  @media (max-width: 700px) {
    user-select: none !important;
    .onlyDesktop { 
      display: none;
    }
  }
`

export const BackTopStyled = styled(BackTop)`
  &.ant-back-top {
    left: 24px !important;
    right: unset !important;
    bottom: 68px !important;
  }
`

export const BackButton = styled.div`
  font-size: 15px;
  display: flex;
  align-items: center;
  background: #ffffffcf;
  border-radius: 90px;
  padding: 10px;
  min-width: 83px;
  font-weight: bold;
  font-family: Avenir;
  box-shadow: 0px 1px 4px -1px grey;
`

export const BackIcon = styled(Icon)`
  font-size: 30px;
  margin-right: 8px;
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  max-width: 1658px;
  margin: 0 auto;
  margin-bottom: ${({ secondary }: DivProps) => secondary ? '0px' : '36px'};
  @media (min-width: 320px) and (max-width: 480px) {
    display: block;
  }

  @media (min-width: 1440px) {
    justify-content: center;
  }
`

export const ComingSoonLayer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 7;
  font-family: Avenir;
  color: white;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2.5px);
  background-color: #000000b0;
`

export const ComingSoonLabel = styled.div`
  margin-top: 14px;
  font-size: 38px;
  font-weight: bold;
  filter: drop-shadow(2px 4px 6px #505050);
`

export const GetNotified = styled.div`
  margin-top: 24px;
  background: #47b97a;
  padding: 6px 8px;
  border-radius: 5px;
  max-width: 200px;
  width: 100%;
  text-align: center;
  font-size: 16px;
  position: relative;
  box-shadow: 1px 2px 3px -1px #545454;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: white;
    color: #47b97a;
  }
`

export const NotifIcon = styled(Icon)`
  position: absolute;
  right: 19px;
  top: 8px;
  color: #fff8e8;
`

export const MenIcon = styled(Icon)`
  margin-left: 8px;
  color: ${BLUE_SKY};
`

export const SizeChart = styled.img`
  max-width: 128px;
  width: 100%;
  object-fit: contain;
  margin: 0 0 30px 0;
  &:hover {
    cursor: pointer;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    max-width: 100%;
    object-fit: contain;
    margin: 0 0 22px 0;
    padding-right: 22px;
    height: 54px;
    width: 100%;
  }
`

export const SizeChartCustom = styled.img`
  max-width: 128px;
  width: 100%;
  object-fit: contain;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 926px) {
    margin-top: 24px;
    margin-bottom: 16px;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
    margin-top: unset;
    margin-bottom: unset;
  }
`

export const SizeChartCustomMobile = styled.img`
  max-width: 128px;
  width: 100%;
  object-fit: contain;
  display: none;
  &:hover {
    cursor: pointer;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
  }
`

export const MobileFlex = styled.div`
  display: none;
  justify-content: space-around;
  align-items: center;
  margin: 22px 0;
  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
  }
`

export const YouthLabel = styled.div`
  font-size: 12px;
  color: #549c8c;
  margin-left: 5px;
  display: inline-block;
  vertical-align: bottom;
`

export const WomenIcon = styled(Icon)`
  margin-left: 2px;
  color: deeppink;
`
export const ImagePreview = styled.div`
  width: 40%;
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
    padding: 0;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    width: 100%;
  }

  @media (min-width: 1440px) {
    max-width: 1000px;
  }
  .swipeImg {
    max-height: 554px;
  }
`

export const ProductData = styled.div`
  padding: 18px;
  width: 60%;
  padding-bottom: 0px;
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
    padding: 14px;
  }
`
export const Title = styled.div`
  color: #2b2b2c;
  font-size: 24px;
  font-weight: bold;
  line-height: 33px;

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 18px;
    white-space: nowrap;
    padding-bottom: 2px;
  }
`

export const HowItFits = styled.div`
  margin: 16px 0;
  margin-bottom: 16px;
  height: 34px;
  width: 154px;
  color: ${WHITE};
  border: 1px solid ${GRAY_LIGHT};
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  transition: all 0.2s ease;
  z-index: 2;
  background: transparent;
  cursor: pointer;
  &:hover {
    background: gainsboro;
    color: ${BLACK_3D_DARK};
    font-weight: bold;
  }
`
export const BannerMaterialSection = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  margin-top: 8px;
  @media (max-width: 698px) {
    margin-top: ${({ secondary }: DivProps) => secondary ? '8px' : '0px'};
  }
`

export const BannerMaterial = styled.img`
  max-width: 74px;
  object-fit: cover;
  max-height: 74px;
  margin-right: 8px;
  border-radius: 3px;
  @media (max-width: 698px) {
    margin-right: 0px;
  }
`

export const Subtitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  line-height: 19px;

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 12px;
  }
`

export const TitleSubtitleContainer = styled.div``

export const StyledLink = styled.a`
  @media (min-width: 320px) and (max-width: 480px) {
    align-self: center;
  }
`

export const ColorButtons = styled.div`
  display: flex;
  flex-flow: column;
  position: absolute;
  left: 25px;
  top: 20px;
  z-index: 3;
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) 2s both;
  @keyframes fade-in-left {
    0% {
      transform: translateX(-7px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

export const ToneButton = styled.img`
  object-fit: contain;
  height: 27px;
  width: 27px;
  background: ${({ selected }: StyledProps) =>
    selected ? GRAY_LIGHTEST : WHITE};
  padding: 5px;
  margin-bottom: 8px;
  border-radius: 25px;
  box-shadow: ${({ selected }: StyledProps) =>
    selected ? 'unset' : `0px 2px 3px -1px ${GRAY_DARK}`};
  transition: all 0.25s;
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
`

export const ModelContainer = styled.div`
  background: #4a4a4a;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  flex-flow: column;
  border-radius: 3px;
  position: relative;
  user-select: none !important;
`

export const InlineContainer = styled.div`
  position: relative;
`

export const StyledBreadCrumb = styled(Breadcrumb)`
  border: 1px solid ${GRAY_LIGHT};
  padding: 10px 0 10px 49px;
  background-color: ${WHITE};
`

export const StyledInputNumber = styled(InputNumber)`
  border-radius: 0px;
  height: 40px;
  width: 138px;
  border: 1px solid ${GRAY};
`

export const AvailablePrices = styled.div`
  margin-right: 20px;

  @media (min-width: 320px) and (max-width: 480px) {
    margin: 0;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    margin-right: 20px;
  }
`

export const PricesRow = styled.div`
  display: flex;
  margin-top: ${({ secondary }: DivProps) => secondary ? '20px' : '0px'};
  @media (min-width: 320px) and (max-width: 480px) {
    justify-content: space-between;
    margin-top: ${({ secondary }: DivProps) => secondary ? '12px' : '10px'};
  }
  ${({ third }: DivProps) => third ? `
    & > div > div {
      display: none;
      :first-child {
        display: block;
      }
    }
  ` : ''}
`

export const PriceOnlyDesktop = styled.div`
display: none;
@media (min-width: 768px) {
  display: flex;
}
`

export const PriceOnlyMobile = styled.div`
display: none;
@media (min-width: 320px) and (max-width: 480px) {
  display: flex;
  column-gap: 12px;
}
`

export const Description = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  line-height: 23px;
`

export const DescriptionRich = styled.div`
  width: 100%;
  margin-top: -10px;
  line-height: 1.27;
  @media (max-width: 528px) {
    margin-top: -10px;
  }
`

export const ProductDescription = styled.div`
`

export const DescriptionTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 14px;
  text-align: center;
  background: #EFF2F4;
  padding: 6px;
`

export const DescriptionSection = styled.div`
  max-width: 1282px;
  margin: 0 auto;
  padding: 0 48px;
  @media (max-width: 698px) {
    padding: 0px 18px;
    margin-top: 32px;
  }
`

export const ButtonsRow = styled.div`
  display: flex;
  margin: 20px 0 25px;

  .ant-btn {
    color: ${({ disabled }: StyledProps) => disabled ? GRAY : WHITE} !important;
    border-color: ${({ disabled }: StyledProps) => disabled ? GRAY_HEADER : '#2b2b2c'} !important;
    background-color: ${({ disabled }: StyledProps) => disabled ? GRAY_HEADER : '#2b2b2c'} !important;
    font-size: 16px;
    border-radius: 3px;
    line-height: 22px;
    text-align: center;
    box-shadow: 1px 2px 5px 0px #b4b4b4;
    &:hover {
      cursor: ${({ disabled }: StyledProps) => disabled ? 'not-allowed' : 'pointer'};
    }
  }
  @media (max-width: 698px) {
    width: 100%;
    margin: 8px 0 25px;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    flex-flow: column;
  }
  &:hover {
    cursor: ${({ disabled }: StyledProps) => disabled ? 'not-allowed' : 'pointer'};
  }
`

export const CartLabel = styled.div``

export const CartIcon = styled(Icon)`
  margin-right: 10px;
`

export const StyledButtonWrapper = styled.div`
  .ant-btn-primary  {
    background-color: ${BLUE_DARK};
    border-color: ${BLUE_DARK};
  }
  .ant-btn-primary:hover {
    background-color: ${BLUE_DARK};
    border-color: ${BLUE_DARK};
  }
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 18px 0 0;
  }
  margin-left: ${({ marginLeft }: StyledProps) => marginLeft || '0px'};
`
export const SlideImage = styled.img`
  width: 100%;
`

export const SlideVideo = styled.video`
  width: 100%;
`

export const SlideImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
`

export const Separator = styled.div`
  text-align: center;
  margin: 48px 10% 28px 10%;
  padding-bottom: 8px;
  border-bottom: 1px solid ${GRAY_LIGHT};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.93px;
  line-height: 18px;
`

export const TitleName = styled.div`
  margin-right: 8px;
`

export const StyledButton = styled.div`
  height: 50px;
  width: 277px;
  border: 1px solid #2b2b2c;
  border-radius: 3px;
  cursor: pointer;
  font-weight: 600;
  background: #2b2b2c;
  color: ${WHITE};
  box-shadow: 1px 2px 4px -1px #9d9d9d;
  font-size: 16px;
  display: flex;
  transition: all 0.2s;
  justify-content: center;
  align-items: center;
  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
  }
  &:hover {
    background-color: ${WHITE};
    color: ${BLUE};
  }
`

export const CustomizeButton = styled.a`
  height: 50px;
  width: 256px;
  border: 1px solid ${BLUE};
  border-radius: 2px;
  cursor: pointer;
  font-weight: 600;
  background-color: ${WHITE};
  box-shadow: 1px 2px 4px -1px #9d9d9d;
  color: ${BLUE};
  font-size: 16px;
  display: flex;
  transition: all 0.2s;
  justify-content: center;
  align-items: center;
  &:hover {
    background: ${BLUE};
    color: ${WHITE};
  }
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const ColorWheel = styled.img`
  width: 20px;
  margin-right: 12px;
`

export const MobileButtonWrapper = styled.div`
  width: 100%;
`

export const MobileButton = styled.div`
  display: none;
  height: 50px;
  width: 100%;
  margin-bottom: 16px;
  border: 1px solid #2b2b2c;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
  background-color: #2b2b2c;
  box-shadow: 1px 1px 4px -1px #9d9d9d;
  color: white;
  font-size: 16px;
  justify-content: center;
  align-items: center;

  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
  }
`

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media (max-width: 1024px) {
    flex-flow: column;
  }
  @media (max-width: 768px) {
    flex-direction: row;
  }
`
export const CompareButton = styled(Button)`
  border-color: #5898b6;
  color: #5898b6;
  box-shadow: 1px 1px 4px -1px #9d9d9d;
  padding: 6px 22px;
  height: fit-content;
  font-family: Avenir;
  font-size: 13px;
  font-weight: 500;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  &:focus {
    color: #3998c4;
    border-color: #3998c4;
  }
  @media (max-width: 1024px) {
    align-self: flex-end;
    ${({ secondary }: DivProps) => !secondary && false ? `
      margin-top: -20px;
      margin-bottom: 20px;
    ` : ''};
  }
  @media (max-width: 698px) {
    font-size: 12px;
    padding: 4px 12px;
  }
`

export const BuyNowOptions = styled.div`
  margin-bottom: 40px;
  ${({ secondary }: DivProps) => secondary ? `
    @media (max-width: 698px) {
      display: flex;
      flex-wrap: wrap;
      column-gap: 28px;
      margin-bottom: 0px;
      .sectionRow {
        margin-bottom: 6px;
      }
    }
    .sectionTitle {
      margin-bottom: 8px;
    }
  ` : ''}
`

export const DealerTitle = styled.div`
  margin-top: 8px;
  margin-bottom: -12px;
  color: ${RED};
`

export const GenderRow = styled.div`
  display: flex;
  margin-bottom: 20px;
`
export const SectionTitle = styled.div`
  height: 25px;
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
  margin-bottom: 10px;
`
export const SectionTitleContainer = styled.div`
  display: flex;
`

interface ButtonProps {
  selected: boolean
  large?: boolean
  oneSize?: boolean
  range?: boolean
}

export const SectionButton = styled.div`
  align-content: center;
  background-color: ${({ selected }: ButtonProps) => selected ? BLACK_BG : WHITE};
  color: ${({ selected }: ButtonProps) => selected ? WHITE : 'rgba(0, 0, 0, 0.65)'};
  border: ${({ selected }: ButtonProps) =>
    selected ? `0.5px solid ${BLACK_BG}` : '0.5px solid #dcdcdc'};
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  display: flex;
  margin-right: 14px;
  padding: ${({ range }: ButtonProps) => range ? '8px 16px' : '10px 22px'};
  white-space: nowrap;
  transition: all .25s;
  opacity: ${({ disabled }: StyledProps) => disabled ? '0.6' : '1'};
  margin-bottom: ${({ range }: ButtonProps) => (range ? '8px' : 'unset')};
  justify-content: center;
  width: ${({ large, oneSize }: ButtonProps) => {
    let width = oneSize ? 'auto' : 'fit-content'
    if (large) {
      width = '139px'
    }
    return width
  }};

  &:hover {
    cursor: ${({ disabled }: StyledProps) => disabled ? 'not-allowed' : 'pointer'};
  }

  @media (min-width: 320px) and (max-width: 768px) {
    margin-bottom: 15px;
    border-radius: 0px;
    box-shadow: none;
    border: 0.5px solid ${BLACK_BG};
    &.genderBtn {
      margin-bottom: 10px;
    }
  }
  ${({ highlight }: StyledProps) => highlight ? `
    animation: pulse 1s 0.5s 2;
    @keyframes pulse {
      0% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
        transform: scale(1);
        background-color: #fff3f3 !important;
      }

      70% {
        filter: drop-shadow(0 0 15px rgba(255, 0, 0, 0));
        transform: scale(1.05);
        background-color: #white !important;
      }

      100% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
        transform: scale(1);
        background-color: #fff3f3 !important;
      }
    }
    background-color: #fff3f3 !important;
  ` : ''}
`

export const SectionRow = styled.div`
  margin-bottom: 20px;
`
export const SectionButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (min-width: 320px) and (max-width: 768px) {
    justify-content: start;
  }

  @media (min-width: 769px) and (max-width: 1023px) {
    flex-wrap: wrap;
  }
`
export const SizeRowTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
`

export const GetFittedLabel = styled.div`
  height: 22px;
  color: ${RED};
  font-size: 16px;
  line-height: 22px;
  &:hover {
    cursor: pointer;
  }
`

export const QuestionSpan = styled.span`
  margin-left: 8px;
  height: 20px;
  width: 20px;
  color: ${GRAY_DARK};
  font-size: 14px;
  border: 1px solid #f4f4f4;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  box-shadow: 0px 2px 2px 0px #bebebe;
  &:hover {
    cursor: pointer;
  }
`
export const AddToCartRow = styled.div`
  display: flex;
`

export const AddToCartButton = styled(Button)`
  height: 40px;
  width: 138.23px;
  border-radius: 2px;
  background-color: ${BLUE};
  color: ${WHITE};
  margin-left: 26px;

  &:hover {
    background-color: ${BLUE};
    color: ${WHITE};
    border-color: ${BLUE};
  }
`
export const RelatedProductsContainer = styled.div`
  margin-bottom: 80px;
  padding: 0px 32px;
`
export const ReviewsHeader = styled.div`
  align-items: center;
  background-color: ${GRAY_HEADER};
  color: ${GRAY_DARK};
  display: flex;
  font-size: 18px;
  font-weight: 600;
  height: 38px;
  letter-spacing: 0.23px;
  line-height: 25px;
  margin-bottom: 15px;
  padding-left: 32px;
`

export const YotpoImageSlider = styled.div``

export const Downloadtemplate = styled.div`
  height: 19px;
  color: ${DARKER_GRAY};
  font-size: 14px;
  line-height: 19px;
  margin-left: 10px;
`

export const DownloadTemplateContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-right: 20px;
`
export const DownloadAnchor = styled.a`
  display: flex;
`

export const DownloadImg = styled.img`
  &:hover {
    cursor: pointer;
  }
`
export const DetailsList = styled.ul`
  padding: 10px 0 0 20px;
`

export const DetailsListItem = styled.li`
  margin-bottom: 15px;
`

export const ColorOption = styled.div`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 28px;
  padding: 0px 16px;
  margin-right: 14px;
  margin-bottom: 12px;
  transition: all .25s;
  opacity: ${({ disabled }: StyledProps) => disabled ? '0.45' : '1'};
  &:hover {
    cursor: ${({ disabled }: StyledProps) => disabled ? 'not-allowed' : 'pointer'};
    opacity: 0.8;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    height: 34px;
    width: 34px;
    border-radius: 100%;
    margin-right: 14px;
    transition: all .25s;
  }
`

export const DisabledText = styled.div`
  position: absolute;
  z-index: 3;
  bottom: -16px;
  width: 100%;
  color: #d70000;
  display: flex;
  justify-content: center;
  font-size: 11px;
  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 8px;
  }
`

interface DivProps {
  secondary?: boolean
  third?: boolean
  highlight?: boolean,
  selected?: boolean,
}

export const ColorName = styled.div`
  z-index: 2;
  color: #b0b0b0;
  font-size: 12px;
  mix-blend-mode: difference;
  white-space: nowrap;
  ${({ secondary }: DivProps) => secondary ? `
    color: ${WHITE};
    mix-blend-mode: unset;
  ` : ''};
  @media (min-width: 320px) and (max-width: 480px) {
    display: ${({ selected }: DivProps) => selected ? 'block' : 'none'};
    position: absolute;
    bottom: -18px;
    color: black;
  }
`

export const ProductAvailableColor = styled.img`
  position: absolute;
  z-index: 1;
  object-fit: cover;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 25px;
  transition: all .25s;
  box-shadow: 1px 2px 2px 0px #e1e1e1;
  border: ${({ selected, withBorder }: StyledProps) =>
    selected
      ? `2px solid #ff99a9`
      : (withBorder ? `1px solid ${GRAY_DARK}` : 'none')};
  ${({ highlight }: DivProps) => highlight ? `
    animation: blink-1 1.25s 2 ease-in-out;
    @keyframes blink-1 {
      0% {
        box-shadow: 0 0 0 0 #ff6a6a;
      }
      100% {
        box-shadow: 0 0 0 13px #fff8f8b8;
      }
    }
  ` : ``}
  @media (min-width: 320px) and (max-width: 480px) {
    outline: ${({ selected }: StyledProps) => selected ? '1px solid' : 'none'};
    border: ${({ selected, withBorder }: StyledProps) =>
    selected
      ? '2px solid white'
      : (withBorder ? `1px solid ${GRAY_DARK}` : 'none')};
  }
`

export const ColorWrapper = styled.div`
  min-height: 2.5em;
  @media (max-width: 768px) {
    height: auto;
  }
`

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  align-items: center;
`

export const layoutStyle = {
  backgroundColor: GRAY_HEADER,
}

export const InfoTag = styled.div`
  position: absolute;
  right: 0;
  top: 20px;
  height: 30px;
  padding: 3px 8px;
  background: ${GREEN_STATUS};
  font-family: 'Avenir Next';
  font-style: italic;
  font-weight: bold;
  font-size: 17px;
  z-index: 2;
  &:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-right: 22px solid ${GREEN_STATUS};
    border-bottom: 30px solid transparent;
    margin-left: -30px;
    margin-top: -3px;
  }
`

export const ActionButtonsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0 25px;

  .ant-btn {
    font-size: 16px;
    line-height: 22px;
    text-align: center;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    flex-flow: column;
  }
  @media (min-width: 480px) and (max-width: 940px) {
    display: block;
  }
`

export const MobileButtonTemplate = styled.div`
  display: none;
  justify-content: center;
  color: ${BLUE};
  font-size: 14px;
  font-weight: bold;
  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
  }
`

export const ButtonTemplate = styled.div`
  color: ${BLUE};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
  }
  @media (min-width: 480px) and (max-width: 940px) {
    height: 40px;
    line-height: 40px;
  }
`

export const Download = styled(Icon)`
  margin-right: 10px;
  stroke: ${BLUE};
  stroke-width: 30px;
  font-size: 17px;
`

export const ThreeDButton = styled.img`
  max-width: 54px;
  border-radius: 10px;
  padding: 8px;
  border: 1px solid #7c7c7c;
  margin-top: -12px;
  background: #525252;
  box-shadow: 0px 3px 6px -1px black;
  z-index: 2;
  right: 28px;
  position: absolute;
  bottom: 15px;
  transition: all .5s;
  -webkit-touch-callout: none !important;
  user-select: none !important;
  ${({ selected }: StyledProps) => selected ? `
    background: #4a4a4a;
    box-shadow: 0px 3px 8px -2px black inset;
  ` : ''}
`

export const InfoMessage = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: -28px;
  background: #272727;
  vertical-align: middle;
`

export const FingerIcon = styled.img`
  max-width: 24px;
  vertical-align: middle;
  z-index: 2;
  background: #272727;
  margin-right: 8px;
`

export const QuantitySection = styled.div`
  margin-top: -4px;
  margin-bottom: 32px;
  @media (max-width: 698px) {
    margin-bottom: 22px;
  }
`

export const QuantityDiv = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${GRAY_ANTDESIGN};
  width: fit-content;
  border-radius: 3px;
  font-size: 18px;
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  @media(max-width: 698px) {
    margin: 0 auto;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    border-radius: 0px;
    border: 1px solid ${BLACK_BG};
    margin: 0px;
  }
`

export const MinusButton = styled.div`
  width: 26px;
  text-align: center;
  transition: all .25s;
  height: 24px;
  padding-top: 1px;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
    background: #f7f7f7;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 38px;
    font-size: 24px;
  }
`

export const QuantityInput = styled.input`
  border: none;
  text-align: center;
  width: 33px;
  height: 24px;
  border-left: 1px solid ${GRAY_ANTDESIGN};
  border-right: 1px solid ${GRAY_ANTDESIGN};
  font-size: 15px;
  padding: 3px 0px;
  font-weight: bold;
  font-family: Avenir;
  -moz-appearance: textfield !important;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    width: 40px;
    border-left: 1px solid ${BLACK_BG};
    border-right: 1px solid ${BLACK_BG};
    font-size: 18px;
  }
`

export const PlusButton = styled.div`
  width: 26px;
  text-align: center;
  transition: all .25s;
  height: 24px;
  padding-top: 1px;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
    background: #f7f7f7;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 38px;
    font-size: 24px;
  }
`

export const StyledTooltip = styled(Popover)`
  .ant-popover-inner-content {
    padding-top: 1px;
  }
  @media (max-width: 480px) {
    display: none;
  }
`

export const TextBody = styled.div``

export const TooltipBody = styled.div`
  max-width: 247px;
  width: 100%;
  text-align: center;
`

export const RightButtons = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  @media (max-width: 1024px) {
    align-self: flex-end;
    margin-bottom: -14px;
  }
  @media (max-width: 768px) {
    margin-top: 0px;
    margin-bottom: 3px;
  }
`

export const TopButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: flex-end;
  row-gap: 16px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
  @media (max-width: 698px) {
    flex-flow: column-reverse;
    align-items: flex-end;
    margin-top: 4px;
    row-gap: 6px;
  }
`

export const CoreLabel = styled.div`
  font-size: 13px;
  font-weight: normal;
  border-radius: 4px;
  padding: 7px 10px;
  border: 1px solid #7C7C7C;
  color: #5F6062;
  margin-top: 16px;
  box-shadow: 1px 2px 4px -2px #adadad;
  text-align: center;
  &:hover {
    cursor: help;
  }
  @media (max-width: 907px) {
    text-align: center;
    width: fit-content;
    padding: 7px;
  }
  @media (max-width: 480px) {
    margin-right: 0px;
  }
`

type SelectType = {
  selectWidth?: string
  highlightFields?: boolean
}

export const UpgradesSection = styled.div``

export const UpgradesDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const UpgradeInput = styled.div`
  max-width: 192px;
  width: 100%;
  margin-right: 28px;
  margin-bottom: 20px;
  @media (max-width: 698px) {
    max-width: 158px;
    width: 100%;
    margin-right: 18px;
  }
`

export const UpgradeTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

export const StyledSelect = styled(Select)`
  width: 100%;
  & .ant-select-selection {
    border-color: ${({ highlightFields }: SelectType) =>
    highlightFields ? RED : GRAY_ANTDESIGN};
    transition: all .25s;
  }
  transition: all .25s;
  ${({ highlightFields }: SelectType) => highlightFields ? `
    .ant-select-selection {
      background: #fff3f3;
    }
    animation: pulse 1s 0.5s 2;
    @keyframes pulse {
      0% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
        transform: scale(1);
        .ant-select-selection {
          background: #fff3f3 !important;
        }
      }

      70% {
        filter: drop-shadow(0 0 20px rgba(255, 0, 0, 0));
        transform: scale(1.05);
        .ant-select-selection {
          background: #white !important;
        }
      }

      100% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
        transform: scale(1);
        .ant-select-selection {
          background: #fff3f3 !important;
        }
      }
    }
  ` : ''}
`

export const QuestionSpanUpgrade = styled.span`
  color: #5f6062;
  font-size: 14px;
  margin-left: 8px;
  border: 1px solid #c1c1c1;
  background: #f8f8f8;
  font-weight: 500;
  font-family: Avenir;
  padding: 10px;
  line-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 22px;
  height: 22px;

  &::after {
    content: '?';
  }
  &:hover {
    cursor: pointer;
  }
`

export const maskBlurred = {
  backdropFilter: 'blur(3px)'
}

export const buttonStyleModern = {
  background: WHITE,
  color: 'black',
  border: '1px solid black',
  fontWeight: 600,
  width: '28px',
  padding: 0,
  borderRadius: '25px',
  height: '28px',
}

export const InfoBodyModern = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  #prdTitle {
    font-weight: bold;
    font-size: 18px;
    margin-block: -14px 18px;
  }
  #cardsPrd {
    display: flex;
    max-width: 768px;
    text-align: center;
  }
  .imagePrd {
    max-width: 118px;
  }
`

export const InfoImage = styled.img`
  max-width: 75vw;
  border-radius: 5px;
  display: block;
  width: 100%;
  @media (max-width: 768px) {
    display: none;
  }
`

export const InfoImageMobile = styled.img`
  max-width: 886px;
  border-radius: 5px;
  width: 100%;
  display: none;
  margin-top: 0px;
  @media (max-width: 768px) {
    display: block;
  }
`

export const InfoURL = styled.a`
  color: ${BLUE};
`

export const MSRPDiv = styled.div`
  display: flex;
  margin-top: 12px;
  font-size: 16px;
  font-family: Avenir;
  color: ${GRAY_DARK};
  font-weight: bold;
  @media (max-width: 480px) {
    margin-top: 2px;
  }
`

export const MSRPLabel = styled.div`
  margin-right: 6px;
  font-weight: 500;
`

export const DealerDiv = styled.div`
  display: flex;
  font-family: Avenir;
  font-size: 12px;
`

export const MarginLabel = styled.div`
  margin-left: 6px;
  background: #ffe7cb;
  padding: 0 4px;
  border-radius: 3px;
`

export const Variants = styled.div`
  display: flex;
  flex-flow: column;
  top: 20px;
  z-index: 4;
  left: 18px;
  position: absolute;
  @media (max-width: 1023px) {
    top: 42px;
    left: 18px;
  }
`

export const VariantButton = styled.img`
  width: 50px;
  object-fit: contain;
  max-height: 50px;
  border: 2px solid ${({ selected }: StyledProps) => (selected ? RED : GRAY_LIGHT)};
  border-radius: 3px;
  transition: all 0.25s;
  padding: 5px;
  margin-bottom: 8px;
  cursor: pointer;
  background: ${GRAY_LIGHTEST};
  &:hover {
    background: ${GRAY};
  }
`

export const NotAvailable = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  position: fixed;
  width: 100%;
  background: #000000c4;
  color: white;
  z-index: 1;
  justify-content: center;
  top: 0;
  left: 0;
  height: 100%;
`

export const Loading3DDiv = styled.div`
  height: 656px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 572px) {
    height: 515px;
  }
  @media (max-width: 375px) {
    height: 25em;
  }
  .ant-spin {
    filter: saturate(0) brightness(7);
    transform: scale(1.5);
  }
`

export const QRCodeDiv = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 1px 2px 0px #a3a3a3;
  padding: 4px;
  font-size: 12px;
  border-radius: 3px;
  font-family: Avenir;
  padding-right: 10px;
  margin-right: 20px;
  border-top: 1px solid #e0e0e0;
  transition: all .25s;
  @media (max-width: 698px) {
    display: none;
  }
  &:hover {
    cursor: pointer;
    background: #cbdeff;
  }
`

export const QrCodeIcon = styled.img`
  max-width: 18px;
  margin-right: 8px;
  filter: grayscale(0.5) hue-rotate(47deg);
  @media (max-width: 698px) {
    margin-right: 0px;
  }
`

export const StyledInputReminder = styled(InputComponent)`
  border-radius: 25px;
  margin-right: 14px;
  border: none;
  background: #f4f4f4;
  width: 100%;
  height: 32px;
  padding: 6px 16px;
  margin-top: 4px;
  margin-bottom: 16px;
  border-radius: 25px;
  width: 100%;
`

export const Label = styled.div`
  height: 20px;
  margin-left: 12px;
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
`

export const SaveButton = styled(Button)`
  width: 100%;
  border-radius: 5px;
  height: 36px;
  border: none;
  box-shadow: 1px 2px 3px -1px #aaaaaa;
  color: ${WHITE};
  background: ${BLUE};
  margin-top: 10px;
  @media (max-width: 767px) {
    margin-top: 28px;
    width: 100%;
    margin-right: 0;
    height: 50px;
  }
`

export const CloseButton = styled(Button)`
  width: 100%;
  border-radius: 5px;
  height: 36px;
  box-shadow: 1px 2px 4px -1px #d4d4d4;
  margin-top: 12px;
  border: 1px solid #ececec;
`

export const AssistanceDiv = styled.div`
  position: ${({ secondary }: DivProps) => secondary ? 'unset' : 'absolute'};
  bottom: -4px;
  right: 8px;
  width: fit-content;
  padding: 8px 20px;
  text-align: center;
  font-size: 13px;
  background-color: #e6ffe5;
  border-radius: 5px;
  border: 1px solid #bfe5b8;
  @media (max-width: 1128px) {
    position: unset;
  }
  @media (max-width: 768px) {
    font-size: 10px;
    padding: 10px 18px;
  }
  @media (max-width: 740px) {
    justify-content: center;
  }
  @media (max-width: 480px) {
    width: 100%;
  }
  #sectionLink {
    color: ${BLUE};
    margin-top: 8px;
    display: block;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductDetail/styledComponents.tsx